import React, { useEffect, useMemo, useState } from "react";
import {
  Col, Row, Card, CardBody, Button, Spinner, Alert, Modal, ModalHeader, ModalBody, ModalFooter, FormGroup, Label, Input
} from "reactstrap";
import TableContainer from "../../../components/Common/TableContainer";
import Breadcrumbs from "../../../components/Common/Breadcrumb";

const BASE_URL = "https://harmanappapi.stechomeyazilim.info";

const getAuthHeaders = () => {
  const authUser = JSON.parse(localStorage.getItem("authUser") || "{}");
  const token = localStorage.getItem("token") || authUser?.Token;
  return {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };
};

const SistemAyarları = () => {
  document.title = "Sistem Ayarları | HarmanaGEL";

  const [ayarlar, setAyarlar] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [successMsg, setSuccessMsg] = useState("");

  const [editModal, setEditModal] = useState(false);
  const [selectedAyar, setSelectedAyar] = useState(null);
  const [editForm, setEditForm] = useState({});
  const [editLoading, setEditLoading] = useState(false);

  const fetchAyarlar = async () => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await fetch(
        `${BASE_URL}/AYARLAR?$top=500&$orderby=ANAHTAR asc`,
        { headers: getAuthHeaders() }
      );
      const result = await response.json();
      if (result && result.value) setAyarlar(result.value);
    } catch (err) {
      setError("Ayarlar yüklenirken hata oluştu.");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchAyarlar();
  }, []);

  const handleOpenEdit = (ayar) => {
    setSelectedAyar(ayar);
    setEditForm({
      DEGER: ayar.DEGER || "",
      ACIKLAMA: ayar.ACIKLAMA || "",
    });
    setEditModal(true);
  };

  const handleEditSave = async () => {
    setEditLoading(true);
    try {
      await fetch(`${BASE_URL}/AYARLAR(${selectedAyar.ID})`, {
        method: "PATCH",
        headers: getAuthHeaders(),
        body: JSON.stringify({
          DEGER: editForm.DEGER,
          ACIKLAMA: editForm.ACIKLAMA,
        }),
      });
      setSuccessMsg("Ayar güncellendi.");
      setEditModal(false);
      fetchAyarlar();
      setTimeout(() => setSuccessMsg(""), 3000);
    } catch {
      setError("Güncelleme sırasında hata oluştu.");
    } finally {
      setEditLoading(false);
    }
  };

  const columns = useMemo(() => [
    {
      header: "ID",
      accessorKey: "ID",
      enableSorting: true,
      enableColumnFilter: false,
      cell: (cell) => <span className="fw-bold">#{cell.getValue()}</span>,
    },
    {
      header: "Anahtar",
      accessorKey: "ANAHTAR",
      enableSorting: true,
      enableColumnFilter: true,
      cell: (cell) => <span className="fw-medium font-monospace">{cell.getValue()}</span>,
    },
    {
      header: "Değer",
      accessorKey: "DEGER",
      enableSorting: true,
      enableColumnFilter: true,
      cell: (cell) => <span className="fw-bold text-primary">{cell.getValue()}</span>,
    },
    {
      header: "Açıklama",
      accessorKey: "ACIKLAMA",
      enableSorting: false,
      enableColumnFilter: true,
      cell: (cell) => <span className="text-muted">{cell.getValue() || "-"}</span>,
    },
    {
      header: "İşlemler",
      enableSorting: false,
      enableColumnFilter: false,
      cell: (cellProps) => {
        const a = cellProps.row.original;
        return (
          <Button color="primary" size="sm" outline onClick={() => handleOpenEdit(a)}>
            <i className="bx bx-edit me-1" /> Düzenle
          </Button>
        );
      },
    },
  ], []);

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="HarmanaGEL" breadcrumbItem="Sistem Ayarları" />

          {successMsg && <Alert color="success">{successMsg}</Alert>}
          {error && <Alert color="danger" toggle={() => setError(null)}>{error}</Alert>}

          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <h4 className="card-title mb-0">Sistem Ayarları</h4>
                    <Button color="primary" size="sm" onClick={fetchAyarlar} disabled={isLoading}>
                      <i className="bx bx-refresh me-1" />
                      Yenile
                    </Button>
                  </div>

                  {isLoading ? (
                    <div className="text-center py-5"><Spinner color="primary" /></div>
                  ) : (
                    <TableContainer
                      columns={columns}
                      data={ayarlar}
                      isGlobalFilter={true}
                      SearchPlaceholder="Ayar ara..."
                      isPagination={true}
                      isCustomPageSize={true}
                      tableClass="table-bordered align-middle nowrap w-100 mb-0"
                      theadClass="table-light"
                      paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                    />
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>

      <Modal isOpen={editModal} toggle={() => setEditModal(false)} centered>
        <ModalHeader toggle={() => setEditModal(false)}>
          Ayar Düzenle: {selectedAyar?.ANAHTAR}
        </ModalHeader>
        <ModalBody>
          <FormGroup>
            <Label>Değer</Label>
            <Input
              value={editForm.DEGER || ""}
              onChange={(e) => setEditForm({ ...editForm, DEGER: e.target.value })}
              placeholder="Ayar değeri"
            />
          </FormGroup>
          <FormGroup>
            <Label>Açıklama</Label>
            <Input
              type="textarea"
              rows={3}
              value={editForm.ACIKLAMA || ""}
              onChange={(e) => setEditForm({ ...editForm, ACIKLAMA: e.target.value })}
              placeholder="Ayar açıklaması"
            />
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" outline onClick={() => setEditModal(false)} disabled={editLoading}>İptal</Button>
          <Button color="primary" onClick={handleEditSave} disabled={editLoading}>
            {editLoading ? <><Spinner size="sm" className="me-1" />Kaydediliyor...</> : "Kaydet"}
          </Button>
        </ModalFooter>
      </Modal>
    </React.Fragment>
  );
};

export default SistemAyarları;
